export default "__VITE_ASSET__DwgId3Gr__"